import React from 'react';
import { useRouter } from 'next/router';

const VideoCard = ({ video }) => {
    const router = useRouter();

    const handleClick = (slug) => {
        router.push(`/lessons/${slug}`);
    };

    return (
        <div className='relative overflow-hidden cursor-pointer m-2 md:m-4 max-w-[400px]' onClick={() => handleClick(video.slug)}>
            <img src={video?.thumbnail?.url} alt={video?.title} className='w-full h-auto block rounded-t-lg max-h-[241px]' />
            <div className=' bg-[#3E257A]  text-white h-[70px] pt-4 pl-4 text-base rounded-b-lg line-clamp-1'>
                <p className='font-medium my-0 text-sm line-clamp-1'>{video?.title}</p>
            </div>
        </div>
    );
};

export default VideoCard;
